import { useCallback, useEffect, useState } from 'react';

import { getSuppliers } from '@/modules/suppliers/redux/SupplierCRUD';

export interface PurchasingSupplierOption {
  id: string;
  name: string;
  code: string;
}

interface UsePurchasingSuppliersParams {
  companyId?: string;
  search?: string;
  skip?: boolean;
  onError?: (message: string) => void;
}

export default function usePurchasingSuppliers({
  companyId,
  search = '',
  skip = false,
  onError,
}: UsePurchasingSuppliersParams) {
  const [supplierOptions, setSupplierOptions] = useState<PurchasingSupplierOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchSuppliers = useCallback(async (searchValue = '') => {
    setLoading(true);
    try {
      const response = await getSuppliers({
        search: searchValue.trim() || undefined,
        page_size: 50,
        ...(companyId && companyId !== 'global' ? { company_id: companyId } : {}),
      } as any);

      const results: any[] = Array.isArray(response)
        ? response
        : (response as any).results || [];

      setSupplierOptions(
        results.map((s: any) => ({
          id: s.id,
          name: s.name || '',
          code: s.code || '',
        })),
      );
    } catch (_error) {
      onError?.('Không thể tải danh sách nhà cung cấp.');
      setSupplierOptions([]);
    } finally {
      setLoading(false);
    }
  }, [companyId, onError]);

  useEffect(() => {
    if (skip) return;
    const timer = window.setTimeout(() => {
      void fetchSuppliers(search);
    }, 50);
    return () => window.clearTimeout(timer);
  }, [fetchSuppliers, search, skip]);

  const addOption = (option: PurchasingSupplierOption) => {
    setSupplierOptions((prev) => [...prev, option]);
  };

  return { supplierOptions, loading, addOption };
}
